var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isRange
    ? _c("v-date-picker", {
        attrs: {
          masks: _vm.masks,
          attributes: _vm.attributes,
          locale: _vm.locale,
          color: "primary",
          popover: { visibility: "click", placement: "auto" },
          "model-config": _vm.modelConfig,
          "is-range": "",
        },
        on: { input: _vm.handleChange },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function (ref) {
                var inputValue = ref.inputValue
                var inputEvents = ref.inputEvents
                return [
                  _c(
                    "b-row",
                    { staticClass: "range-datepicker" },
                    [
                      _c(
                        "b-col",
                        _vm._b({}, "b-col", _vm.rangeColOptions, false),
                        [
                          _vm._t(
                            "start-date-input",
                            function () {
                              return [
                                _c(
                                  "input",
                                  _vm._g(
                                    {
                                      directives: [
                                        {
                                          name: "mask",
                                          rawName: "v-mask",
                                          value: {
                                            mask: "9999-99-99",
                                            placeholder: "YYYY-MM-DD",
                                            alias: "date",
                                            greedy: false,
                                            showMaskOnHover: false,
                                          },
                                          expression:
                                            "{\n              mask: '9999-99-99',\n              placeholder: 'YYYY-MM-DD',\n              alias: 'date',\n              greedy: false,\n              showMaskOnHover: false\n            }",
                                        },
                                      ],
                                      class:
                                        "material-input form-control form " +
                                        _vm.className,
                                      attrs: {
                                        id: _vm.id ? _vm.id : _vm.labelValue,
                                        autocomplete: _vm.autocomplete,
                                      },
                                      domProps: { value: inputValue.start },
                                    },
                                    inputEvents.start
                                  )
                                ),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "d-none",
                                    attrs: {
                                      for: _vm.id ? _vm.id : _vm.labelValue,
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("global.words.date")))]
                                ),
                              ]
                            },
                            { inputValue: inputValue, inputEvents: inputEvents }
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.showArrowIcon
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-md-flex d-none flex-column justify-content-center align-items-center mb-3",
                            },
                            [
                              _c("icon", {
                                attrs: {
                                  name: "arrow-right",
                                  "icon-class": "icon fe-dp-icon text-primary",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        _vm._b({}, "b-col", _vm.rangeColOptions, false),
                        [
                          _vm._t(
                            "end-date-input",
                            function () {
                              return [
                                _c(
                                  "input",
                                  _vm._g(
                                    {
                                      directives: [
                                        {
                                          name: "mask",
                                          rawName: "v-mask",
                                          value: {
                                            mask: "9999-99-99",
                                            placeholder: "YYYY-MM-DD",
                                            alias: "date",
                                            greedy: false,
                                            showMaskOnHover: false,
                                          },
                                          expression:
                                            "{\n              mask: '9999-99-99',\n              placeholder: 'YYYY-MM-DD',\n              alias: 'date',\n              greedy: false,\n              showMaskOnHover: false\n            }",
                                        },
                                      ],
                                      class:
                                        "material-input form-control form " +
                                        _vm.className,
                                      attrs: {
                                        id: _vm.id ? _vm.id : _vm.labelValue,
                                        autocomplete: _vm.autocomplete,
                                      },
                                      domProps: { value: inputValue.end },
                                    },
                                    inputEvents.end
                                  )
                                ),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "d-none",
                                    attrs: {
                                      for: _vm.id ? _vm.id : _vm.labelValue,
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("global.words.date")))]
                                ),
                              ]
                            },
                            { inputValue: inputValue, inputEvents: inputEvents }
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ],
          null,
          true
        ),
        model: {
          value: _vm.range,
          callback: function ($$v) {
            _vm.range = $$v
          },
          expression: "range",
        },
      })
    : _vm.withInput
    ? _c("v-date-picker", {
        ref: "noRangePicker",
        attrs: {
          value: _vm.maturityDate ? _vm.value : _vm.formattedDate,
          masks: _vm.masks,
          "model-config": _vm.modelConfig,
          attributes: _vm.attributes,
          locale: _vm.locale,
          color: "primary",
          "is-required": "",
          "min-date": _vm.computedMinDate,
          "max-date": _vm.computedMaxDate,
        },
        on: {
          input: function ($event) {
            return _vm.handleChange($event, true)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var togglePopover = ref.togglePopover
              return [
                _c("input", {
                  directives: [
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: {
                        mask: "9999-99-99",
                        placeholder: "YYYY-MM-DD",
                        alias: "date",
                        greedy: false,
                        showMaskOnHover: false,
                      },
                      expression:
                        "{\n        mask: '9999-99-99',\n        placeholder: 'YYYY-MM-DD',\n        alias: 'date',\n        greedy: false,\n        showMaskOnHover: false\n      }",
                    },
                  ],
                  ref: "input",
                  class: "material-input form-control form " + _vm.className,
                  attrs: {
                    id: _vm.id ? _vm.id : _vm.labelValue,
                    type: "text",
                    name: _vm.name,
                    "data-lpignore": "true",
                    disabled: _vm.disabled,
                    tabindex: _vm.tabindex,
                    autocomplete: _vm.autocomplete,
                  },
                  domProps: {
                    value: _vm.maturityDate ? _vm.value : _vm.formattedDate,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.handleChange($event.target.value)
                    },
                    blur: _vm.handleBlur,
                    focus: function (event) {
                      return _vm.handleFocus(event, togglePopover)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.showCalendar
                  ? _c("icon", {
                      attrs: {
                        name: "calendar",
                        "icon-class":
                          "col-lg-1 col-2 icon fe-dp-icon text-primary",
                      },
                      on: { click: _vm.iconClick },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "d-none",
                    attrs: { for: _vm.id ? _vm.id : _vm.labelValue },
                  },
                  [_vm._v(_vm._s(_vm.$t("global.words.date")))]
                ),
              ]
            },
          },
        ]),
      })
    : _c("v-calendar", {
        ref: "datepicker",
        class: { "only-months": _vm.onlyMonths },
        attrs: {
          masks: _vm.masks,
          attributes: _vm.attributes,
          locale: _vm.locale,
          color: "primary",
          "min-date": _vm.computedMinDate,
          "max-date": _vm.computedMaxDate,
        },
        on: {
          dayclick: _vm.handleDayClick,
          "update:to-page": _vm.handleMonthChange,
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }